import React, { useState, useEffect } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { fetchOffers, searchOffers } from "../services/api";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "../styles/Offer.css";
import NotFound from "../components/NotFound";
import { Link } from "react-router-dom";
import Pagination from "../components/Pagination";
import OfferCard from "../components/ui/OfferCard";

const Offer = () => {
  const [offers, setOffers] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    const getOffers = async () => {
      setLoading(true);
      try {
        const response = await fetchOffers(currentPage);

        if (response.success && response.payload) {
          setOffers(response.payload.page || []);
          // Calculate total pages based on size (50 per page)
          const calculatedTotalPages = Math.ceil(response.payload.total / 50);
          setTotalPages(calculatedTotalPages);
        }
      } catch (error) {
        console.error("Failed to fetch offers:", error);
        setOffers([]);
      } finally {
        setLoading(false);
      }
    };

    getOffers();
  }, [currentPage]);

  // Handle search
  const handleSearch = async () => {
    if (!searchTerm.trim()) {
      const response = await fetchOffers(currentPage);
      if (response.success && response.payload) {
        setOffers(response.payload.page || []);
      }
      return;
    }

    setLoading(true);
    try {
      const searchResults = await searchOffers(searchTerm);
      setOffers(searchResults?.payload?.page || []);
    } catch (error) {
      console.error("Search failed:", error);
      setOffers([]);
    } finally {
      setLoading(false);
    }
  };

  // Skeleton loader component
  const OfferSkeleton = () => (
    <div className="col-lg-4 col-md-6 mb-4">
      <div className="project-card style1-1">
        <div className="project-card-img">
          <Skeleton height={250} />
        </div>
        <div className="project-card-details">
          <Skeleton width={200} style={{ marginBottom: "10px" }} />
          <Skeleton width={250} height={24} style={{ marginBottom: "10px" }} />
          <Skeleton width={150} style={{ marginBottom: "8px" }} />
          <Skeleton width={120} style={{ marginBottom: "8px" }} />
          <Skeleton width={200} style={{ marginBottom: "8px" }} />
        </div>
      </div>
    </div>
  );

  return (
    <>
     
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/assets/img/main/m1.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Offers</h1>
            <ul className="breadcumb-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Offers</li>
            </ul>
          </div>
        </div>
      </div>

      <section className="project-sec">
        <div className="container th-container4 bg-white space">
          <div className="container">
            <div className="project-card2-wrap">
              <div className="row align-items-center mb-4">
                <div className="col-lg-6">
                  {" "}
                  <div className="title-area">
                    <span className="sub-title6">OUR OFFERS</span>
                    <h2 className="sec-title">See What We Provide</h2>
                  </div>
                </div>
                <div className="col-lg-6">
                  {" "}
                  <div className="search-area">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search offers..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            handleSearch();
                          }
                        }}
                      />
                      <button
                        className="btn btn-primary"
                        style={{
                          background: "var(--theme-color)",
                          border: "none",
                          padding: "0 25px",
                        }}
                        onClick={handleSearch}
                        disabled={loading}
                      >
                        {loading ? (
                          <span className="spinner-border spinner-border-sm" />
                        ) : (
                          <i className="fas fa-search"></i>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ marginBottom: "120px" }}></div>
              <div className="row">
                {loading ? (
                  // Show 9 skeleton loaders while loading
                  [...Array(9)].map((_, index) => <OfferSkeleton key={index} />)
                ) : offers.length === 0 ? (
                  <NotFound message="No offers found." />
                ) : (
                  // Existing offer items mapping
                  offers.map((item, index) => (
                    <OfferCard key={item.id} item={item} index={index} />
                  ))
                )}
              </div>

              {/* Pagination */}
              {!loading && offers.length > 0 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={(page) => {
                    setCurrentPage(page);
                    window.scrollTo(0, 0);
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Offer;
